<template>
  <div>
    <div :key="product.id" v-for="product in products">
      <form-product
        :product="product"
        @deleteFormProduct="deleteProductForm"
        @handleInput="handleInputValue"
      />
    </div>
  </div>
</template>

<script>
import FormProduct from '../components/FormProduct.vue';
export default {
  components: {
    FormProduct
  },
  props: {
    products: Array,
  },
  methods: {
    deleteProductForm(nameProduct) {
      this.$emit('deleteFormProduct', nameProduct)
    },
    handleInputValue() {
      this.$emit('handleInputProduct')
    }
  }
}
</script>

<style>

</style>